import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { CheckCircle2, ArrowRight, ArrowDown } from 'lucide-react';
export function HeroSection() {
  return <section className="relative w-full bg-[#F8FAFC] overflow-hidden pt-12 pb-20 lg:pt-20 lg:pb-28" data-id="element-49">
      {/* Background accents */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-[#EFF6FF] -skew-x-12 opacity-50 z-0" data-id="element-50" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-blue-100 rounded-full blur-3xl opacity-30 z-0" data-id="element-51" />

      <div className="container mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-52">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-53">
          {/* Left Column: Copy */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.6
        }} className="flex flex-col space-y-6 max-w-2xl mx-auto lg:mx-0 text-center lg:text-left" data-id="element-54">
            <div className="inline-flex items-center justify-center lg:justify-start space-x-2" data-id="element-55">
              <span className="px-3 py-1 rounded-full bg-[#1B3A6B]/10 text-[#1B3A6B] text-sm font-bold tracking-wider uppercase" data-id="element-56">
                PROTOCOLO DE 21 DÍAS · PADRES EN USA
              </span>
            </div>

            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-[#1B3A6B] leading-tight" data-id="element-57">
              Tu hijo tiene potencial de CEO, pero{' '}
              <span className="text-[#F97316]" data-id="element-58">
                tiene el cerebro en piloto automático.
              </span>{' '}
              Vamos a arreglarlo.
            </h1>

            <p className="text-lg sm:text-xl text-slate-600 leading-relaxed" data-id="element-59">
              El sistema de 21 días para niños que "no hacen caso" y solo viven
              para la pantalla — diseñado para padres latinos en USA que ya no
              quieren pelear por el iPad.
            </p>

            <div className="flex flex-col sm:flex-row items-center gap-4 pt-4 justify-center lg:justify-start" data-id="element-60">
              <Button size="xl" className="w-full sm:w-auto group" onClick={() => window.location.href = 'https://enfoquedeacero.com/cart/44821051113574:1'} data-id="element-61">
                QUIERO EL PROTOCOLO AHORA
                <ArrowRight className="ml-2 h-5 w-5 group-hover:translate-x-1 transition-transform" data-id="element-62" />
              </Button>

              <a href="#how-it-works" className="text-[#1B3A6B] font-semibold hover:text-[#2B7FD4] flex items-center gap-2 px-6 py-4 transition-colors" data-id="element-63">
                Ver cómo funciona
                <ArrowDown className="h-4 w-4 animate-bounce" data-id="element-64" />
              </a>
            </div>

            <div className="flex items-center justify-center lg:justify-start gap-2 text-sm font-medium text-slate-500 pt-2" data-id="element-65">
              <CheckCircle2 className="h-5 w-5 text-[#F97316]" data-id="element-66" />
              <span data-id="element-67">Resultados en 21 días garantizados</span>
            </div>
          </motion.div>

          {/* Right Column: Image */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none" data-id="element-68">
            <div className="relative rounded-2xl overflow-hidden shadow-2xl border-4 border-white" data-id="element-69">
              <img src="https://cdn.magicpatterns.com/uploads/gbwV9TKptYX4JrXMAh71PC/heylloyd-image-1771912394573.png" alt="Niño concentrado estudiando con tablet y cronómetro" className="w-full h-auto object-cover" data-id="element-70" />

              {/* Floating Badge */}
              <div className="absolute bottom-6 left-6 bg-white/95 backdrop-blur-sm p-4 rounded-xl shadow-lg border border-slate-100 max-w-xs hidden sm:block" data-id="element-71">
                <div className="flex items-center gap-3" data-id="element-72">
                  <div className="bg-[#1B3A6B] p-2 rounded-full text-white" data-id="element-73">
                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-74">
                      <circle cx="12" cy="12" r="10" data-id="element-75" />
                      <polyline points="12 6 12 12 16 14" data-id="element-76" />
                    </svg>
                  </div>
                  <div data-id="element-77">
                    <p className="text-xs text-slate-500 font-semibold uppercase" data-id="element-78">
                      Enfoque Promedio
                    </p>
                    <p className="text-[#1B3A6B] font-bold text-lg" data-id="element-79">
                      +300% Mejora
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Decorative elements behind image */}
            <div className="absolute -top-6 -right-6 w-24 h-24 bg-[#F97316] rounded-full opacity-20 blur-2xl -z-10" data-id="element-80" />
            <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-[#2B7FD4] rounded-full opacity-20 blur-2xl -z-10" data-id="element-81" />
          </motion.div>
        </div>
      </div>
    </section>;
}